import type { Float } from "@pdfking/tfunc"

export type PageNumber = Float<"PageNumber", "i64">
